import React, { useEffect, useState } from 'react';
import '../Scheduling.css';

export function WeekDaysChoise({ selectedDate, setSelectedDate, filterDate }) {
  const [weekDays, setWeekDays] = useState([]);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (selectedDate) {
      const days = [];
      const firstDayOfWeek = new Date(selectedDate);
      const dayOfWeek = firstDayOfWeek.getDay();
      firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek + 1);

      for (let i = -1; i < 6; i++) {
        const day = new Date(firstDayOfWeek);
        day.setDate(firstDayOfWeek.getDate() + i);
        days.push(day);
      }

      setWeekDays(days);
    }
  }, [selectedDate]);

  const handleDayClick = (day) => {
    setSelectedDate(day);
  };

  const filterDateString = filterDate?.map((el) => el?.toDateString());

  return (
    <div className="daysChoise">
      {weekDays?.map((day, index) => {
        const dayCopy = new Date(day);
        dayCopy.setHours(0, 0, 0, 0);

        const isPastDate = dayCopy < currentDate;
        const isPastDateInFilter = filterDate?.some(
          (date) => date?.toDateString() === day?.toDateString(),
        );
        const isPastDateAndInFilter = isPastDate && isPastDateInFilter;
        return (
          <div
            key={index}
            className={`cardChoise ${
              day?.getDate() === selectedDate?.getDate() ? 'selected' : ''
            } ${
              filterDateString?.includes(day?.toDateString())
                ? 'future-event'
                : ''
            } ${isPastDateAndInFilter ? 'past-event' : ''}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '60px',
              height: '50px',
              gap: '6px',
              borderBottom:
                day?.getDate() === selectedDate?.getDate()
                  ? '2px solid var(--primary-color)'
                  : '',
            }}
            onClick={() => handleDayClick(day)}
          >
            <h1 className="day">{day?.getDate()}</h1>
            <h1 className="weekday">
              {['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'][day?.getDay()]}
            </h1>
          </div>
        );
      })}
    </div>
  );
}
